import m1_examRegMenu from "@components/examRegMenu/m1_examRegMenu";
import m2_examRegMenu from "@components/examRegMenu/m2_examRegMenu";
import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
    components: {
        'm2ExamRegMenu': m2_examRegMenu,
        "m2Sidebar": m2Sidebar,
        "m1ExamRegMenu": m1_examRegMenu
    },
    data: function () {
        return {
            batchList: [],
            batch_id: '',
        }
    },
    created: function () {
        this.getData();
        this.$store.commit('setHeaderState', '3');
    },
    methods: {
        getData: function () {
            if (this.$store.state.examInfo.currentExamInfo.batch_id) {
                this.batch_id = this.$store.state.examInfo.currentExamInfo.batch_id;
                this.nextStep()
            } else {
                
                this.$http.get(globalProvider.serviceUrl('e_reg/g/bli')).then((data) => {
                    if (data.body.code === resultCode.Success) {
                        this.$store.commit('setBatch', data.body.data.length);
                        if (data.body.data.length == 0) {
                            this.$router.push({ name: 'default.examReg.closeTip' })
                        }
                        else if (data.body.data.length == 1) {
                            this.batch_id = data.body.data[0].id;
                            this.nextStep()
                        }
                        else {
                            this.batchList = data.body.data;
                        }
                    }
                    else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message), '提示', {
                            confirmButtonText: '确定'
                        });
                    }
                })
            }

        },
        nextStep: function () {
            if (this.batch_id !== "") {
                this.$http.get(globalProvider.serviceUrl('e_reg/g/bpe/{batch_id}'), {
                    params: {
                        batch_id: this.batch_id
                    }
                }).then((data) => {
                    if (data.body.code === resultCode.Success) {
                        this.createRegId();
                    }
                    else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message));
                    }
                })
            }
            else {
                this.$alert('请选择一个批次', '提示', {
                    confirmButtonText: '确定'
                });
            }
        },
        createRegId: function () {
            this.$http.post(globalProvider.serviceUrl('e_reg/a/er'))
                .then((data) => {
                    if (data.body.code === resultCode.Success) {
                        this.getRegModel(data.body.data);
                    }
                    else if (data.body.code == resultCode.NotSuccess) {
                        if (data.body.message == "EXM_REG_CNERC_03") {

                            this.$alert(`您已报考${data.body.data},不可重复报考`)
                        } else {
                            this.$alert(getErrorMessage(data.body.message));
                        }
                    }
                })
        },
        getRegModel: function (reg_id) {
            let reg_info_operation = 1;
            this.$http.get(globalProvider.serviceUrl('e_reg/g/eri/{reg_id}/{reg_info_operation}'), { params: { reg_id: reg_id, reg_info_operation: reg_info_operation } })
                .then((data) => {
                    if (data.body.code === resultCode.Success) {
                        this.$store.commit('setExamRegInfo', data.body.data);
                        this.getPromise(data.body.data.audit_status);
                    }
                    else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message));
                    }
                })
        },
        getPromise: function (audit_status) {
            this.$http.get(globalProvider.serviceUrl('e_reg/g/elc')).then((data) => {
                if (data.body.code == resultCode.Success) {
                    this.$store.commit('setPromiseState', data.body.data.status);
                    if (audit_status === auditStatus.TO_BE_SUBMIT) {
                        if (data.body.data.status) {
                            this.$router.push({ name: 'default.examReg.examNotes' })
                        }
                        else {
                            this.$router.push({ name: 'default.examReg.baseCollection' })
                        }
                    }
                    else {
                        this.$router.push({ name: 'default.examReg.confirmRegInfo' });
                    }
                }
                else if (data.body.code == resultCode.NotSuccess) {
                    this.$alert(getErrorMessage(data.body.message), '提示', {
                        confirmButtonText: '确定'
                    });
                }
            });
        },
    }
}